// extracted by mini-css-extract-plugin
export default {"container":"cr-z","brandName":"dr-z","productName":"er-z","productNamePdpEnhancements":"fr-z","breakLongProductName":"gr-z"};